import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function FileexportContentReducer(state = initialState.fileexportContent, action: any) {
  switch (action.type) {
    case types.SAVE_FILEEXPORTCONTENT_SUCCESS:
      return action.fileexportContent;
    default:
      return state;
  }
}
